import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_SignUp_SignIn',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportalqat.b2clogin.com/tfp/mncportalqat.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://sdoh.portalqat.mynexuscare.com/',
  apiUrl: 'https://api-sdoh.portalqat.mynexuscare.com/api',
  platformUrl: 'https://api-platform.portalqat.mynexuscare.com/api',
  hhApiUrl: 'https://api-homehealth.portalqat.mynexuscare.com/api',
  registryUrl: `https://api-platform.portalqat.mynexuscare.com/api/app-registry`,
  wccLibraryUrl: 'https://mncregqat.blob.core.windows.net/documentlibrary/hh/wcc/library',
  notificationsGatewayUrl: 'https://api-notification-gateway.portalqat.mynexuscare.com',
  specialtyProgramsUrl: 'https://api-specialtyprograms-gateway.portalqat.mynexuscare.com/api',
  authConfig: {
    config: {
      auth: {
        clientId: 'a8044264-7310-4f2b-b77b-b6d3ce68b06f',
        postLogoutRedirectUri: 'https://sdoh.portalqat.mynexuscare.com',
        redirectUri: 'https://sdoh.portalqat.mynexuscare.com',
        knownAuthorities: ['mncportalqat.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`
      },
    },
    angularConfig: {
      consentScopes: [
        'https://mncportalqat.onmicrosoft.com/api/api.Write',
        'https://mncportalqat.onmicrosoft.com/api/api.Read',
        'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
      ],
      protectedResourceMap: [
        [
          'https://api-sdoh.portalqat.mynexuscare.com/*',
          [
            'https://mncportalqat.onmicrosoft.com/api/api.Write',
            'https://mncportalqat.onmicrosoft.com/api/api.Read',
            'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://api-homehealth.portalqat.mynexuscare.com/*',
          [
            'https://mncportalqat.onmicrosoft.com/api/api.Write',
            'https://mncportalqat.onmicrosoft.com/api/api.Read',
            'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://api-platform.portalqat.mynexuscare.com/*',
          [
            'https://mncportalqat.onmicrosoft.com/api/api.Write',
            'https://mncportalqat.onmicrosoft.com/api/api.Read',
            'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
          ]
        ]
      ]
    }
  }
};
